import { createRoute } from '@tanstack/react-router';
import { rootRoute } from 'routes/rootRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const redirectTradeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/redirect/trade/$tradeId',
  params: z.object({ tradeId: zodPathParamId }),
  validateSearch: z.object({
    lab_trade_id: z.number(),
  }),
}).lazy(() => import('pages/redirect/RedirectTrade/RedirectTradePage').then((d) => d.Route));
